<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <!-- For DAC6 we don't need it. We will revisit when we will release Data Survey -->
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--        <button mat-button class="orbitax-flat-button" (click)="addSurvey()"-->
        <!--                particleAnalytics-->
        <!--                analyticsCategory= "data-survey"-->
        <!--                analyticsAction= "Add-Folder">Add Template</button>-->
        <!--        <div class="toolbar-separator"></div>-->
        <!--      </div>-->
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="importSurvey()"
                  particleAnalytics
                  analyticsCategory="data-survey"
                  analyticsAction="Add-Folder">Import Template
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <!--<div class="button-container" fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="orbitax-flat-button" (click)="addSurvey()"
                  particleAnalytics
                  analyticsCategory= "data-survey"
                  analyticsAction= "Add-Folder">Export Template</button>
          <div class="toolbar-separator"></div>
        </div>-->
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <button mat-button class="orbitax-flat-button" (click)="openForms()"-->
        <!--                  particleAnalytics-->
        <!--                  analyticsCategory= "data-survey"-->
        <!--                  analyticsAction= "Add-Folder">Design FlowChart</button>-->
        <!--          <div class="toolbar-separator"></div>-->
        <!--        </div>-->
      </div>
    </div>

  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">


      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="data-survey-overview" class="content-card mat-white-bg">

        <div class="content pos-relative m-30f flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   sortFieldKey="ModifiedDate"
                                   sortDirection="desc"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

